import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { CtaButton } from './CtaButton';
interface StickyCtaProps {
  copiesLeft: number;
}
export function StickyCta({
  copiesLeft
}: StickyCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > 900);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-241" data-mp="3gl72fszluz52">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 28
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-gold-500/20 bg-noir-900/95 backdrop-blur-xl" data-id="element-242" data-mp="3gkfi5ebgknu3">
          <div className="container flex items-center justify-between gap-4 py-3.5" data-id="element-243" data-mp="gztm3ykyx4c6">
            <div className="hidden sm:block" data-id="element-244" data-mp="765hayjg0see">
              <p className="font-display text-lg font-semibold leading-none text-cream" data-id="element-245" data-mp="27b02114jbwe">
                Bundle completo — 5 ebooks
              </p>
              <p className="mt-1.5 flex items-center gap-2 text-xs text-cream/55" data-id="element-246" data-mp="gx072cvwea4l">
                <span className="line-through" data-id="element-247" data-mp="c3e276vz7ajc">$137.00</span>
                <span className="font-semibold text-gold-400" data-id="element-248" data-mp="pvu94irzzspj">$9.99 hoy</span>
                <span className="h-1 w-1 rounded-full bg-crimson-500" aria-hidden="true" data-id="element-249" data-mp="lus8pymchalz" />
                <span data-id="element-250" data-mp="lx4mdzl2kyt8">Solo {copiesLeft} copias</span>
              </p>
            </div>
            <div className="flex flex-1 items-center justify-between gap-4 sm:flex-none" data-id="element-251" data-mp="zsgt75ci2fqi">
              <p className="text-xs text-cream/55 sm:hidden" data-id="element-252" data-mp="uw9k53ot4o4c">
                <span className="line-through" data-id="element-253" data-mp="31l4qky2gq8yd">$137</span>{' '}
                <span className="font-semibold text-gold-400" data-id="element-254" data-mp="2wmteegop3mcz">$9.99</span>
              </p>
              <CtaButton size="md" className="whitespace-nowrap" data-id="element-255" data-mp="2wp64jh4lx314">
                <Lock className="h-4 w-4" aria-hidden="true" data-id="element-256" data-mp="10l9j2v3jsx2x" />
                Quiero los 5 ebooks
              </CtaButton>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}